import React, { ReactNode } from 'react';

import './lesson-passport__footer.scss';

interface Props {
    children: ReactNode | ReactNode[];
}

export const LessonPassportFooter = React.memo(({ children }: Props) => {
    return <div className="lesson-passport__footer">{children}</div>;
});
